export const formasAutorizacao = [
    { value: 1, text: 'Diretoria Administrativa Finaneira' },
    { value: 2, text: 'Diretoria Técnica' },
    { value: 3, text: 'Diretor Superintendente' },
    { value: 4, text: 'Direx' },
    { value: 5, text: 'Gerente' }
]